// src/pages/GalleryPage.js
import React from 'react';
import { useLang } from '../i18n/LanguageContext';
import { Breadcrumb, PhotoSlot, usePageTitle } from '../components/layout/PageBits';

// Masonry grid of real office and event photos. Until Kalyani sends real photos, labelled slots
// show where they go (the old gallery used stock pictures that were not of Kalyani's office).
const SLOTS = [
  ['gOffice', 'row-span-2'], ['gTeam', ''], ['gEvent', ''], ['gClients', 'row-span-2'], ['gFront', ''], ['gEvent2', ''],
];

function GalleryPage() {
  const { t } = useLang();
  usePageTitle(t('gallery'));
  return (
    <section className="bg-white py-10 sm:py-14 min-h-[70vh]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <Breadcrumb current={t('gallery')} />
        <h1 className="text-3xl sm:text-5xl font-extrabold tracking-tight">{t('gallery')}</h1>
        <p className="mt-3 text-slate-600">{t('gSub')}</p>
        <div className="mt-8 grid grid-cols-2 md:grid-cols-3 auto-rows-[150px] sm:auto-rows-[200px] gap-3 sm:gap-4">
          {SLOTS.map(([k, span]) => <PhotoSlot key={k} label={t(k)} className={`rounded-2xl ${span}`} />)}
        </div>
      </div>
    </section>
  );
}

export default GalleryPage;
